var _ellipse, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkedinIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 49,
    viewBox: "0 0 48 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 24,
    cy: 24.5,
    rx: 24,
    ry: 24.5,
    fill: "#09041C"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.9992 31.174V25.9863C31.9992 23.4368 31.4255 21.4893 28.3158 21.4893C26.8164 21.4893 25.8169 22.2683 25.4097 23.0119H25.3727V21.7195H22.4297V31.174H25.5023V26.4821C25.5023 25.2427 25.7429 24.0566 27.3347 24.0566C28.9081 24.0566 28.9266 25.4552 28.9266 26.5529V31.1562H31.9992V31.174Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4316 21.7188H20.5043V31.1733H17.4316V21.7188Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9684 17.0098C17.9873 17.0098 17.1914 17.7711 17.1914 18.7095C17.1914 19.6478 17.9873 20.4268 18.9684 20.4268C19.9494 20.4268 20.7453 19.6478 20.7453 18.7095C20.7453 17.7711 19.9494 17.0098 18.9684 17.0098Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedinIcon);
export default __webpack_public_path__ + "static/media/linkedin-icon.43204c29df61054151e2265d14a9b3f4.svg";
export { ForwardRef as ReactComponent };